export const START_TREATMENT_BUTTON = 'START_TREATMENT_BUTTON';
export const END_CALL_KEY = 'END_CALL_KEY';
